var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-flex eu-justify_space-between eu-align-items_center" },
    [
      _c("div", { staticClass: "eu-flex-item eu-basis_12 eu-basis_5_lg" }, [
        _c("p", { staticClass: "emd-text _type_label _size_tiny eu-mb_1" }, [
          _vm._v(" " + _vm._s(_vm.paymentMethod) + " "),
          _vm.brand
            ? _c("span", [_vm._v(" - " + _vm._s(_vm.brand))])
            : _vm._e(),
        ]),
      ]),
      _vm.brand
        ? _c(
            "div",
            { staticClass: "eu-flex-item eu-basis_12 eu-basis_5_lg" },
            [_c("jade-brand", { attrs: { use: _vm.brand, size: "xlarge" } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }